import { useFormContext } from 'react-hook-form';
import { Card, LocalizedModerateHighlight } from '@mews-commander/ui';
import { FormCheckboxField, FormInputField, LocalizedText, lt } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { Button, Stack, StackItem, Typography } from '@optimus-web/core';
import { AccountType } from '@mews-commander/data-access';
import { AddressFormFields } from '../../../components/form/hookFields';
import { EMPTY_ADDRESS_FORM_VALUES } from './constants';
import { ChangeBillingDetailsFormValues } from './types';

interface Props {
    allowCustomerBillAddressObjection: boolean;
}
const addOwnerPrefix = (value: string) => `owner.address.${value}`;

export const ChangeOwnerDetailsFields = ({ allowCustomerBillAddressObjection }: Props) => {
    const { setValue, watch } = useFormContext<ChangeBillingDetailsFormValues>();
    const ownerAccountType = watch('owner.type');

    return (
        <Card>
            <Stack spacing="300" vertical>
                <LocalizedModerateHighlight textKey={TextKey.ChangeBillOwnerDetailsTitle} />
                <Stack vertical spacing="50">
                    <FormInputField name="owner.name" disabled size="medium" label={lt('ChangeBillOwnerName')} />
                    <Typography textStyle="bodyMedium" variant="secondary" as="div">
                        {lt('ChangeBillOwnerNameCaption')}
                    </Typography>
                    {allowCustomerBillAddressObjection && ownerAccountType === AccountType.Customer ? (
                        <FormCheckboxField name="owner.ownerAddressObjection">
                            {lt('BillCustomerAddressObjection')}
                        </FormCheckboxField>
                    ) : null}
                </Stack>
                <AddressFormFields
                    addressSearchAutocomplete
                    autocompleteLabel={TextKey.ChangeBillingDetailsSearchAddressLabel}
                    size="medium"
                    transformFieldName={addOwnerPrefix}
                    transformDataTestId={addOwnerPrefix}
                />
                <StackItem>
                    <Button
                        onClick={() => {
                            setValue('owner.address', EMPTY_ADDRESS_FORM_VALUES, { shouldDirty: true });
                        }}
                        size="medium"
                        type="button"
                    >
                        <LocalizedText textKey={TextKey.ClearAddress} />
                    </Button>
                </StackItem>
            </Stack>
        </Card>
    );
};
